import React from "react";
import styles from "./Footer.module.css";
import { useTranslation } from "react-i18next";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["bottom-container"]}>
      <div className={styles["footer-container"]}>
        <div className={styles["footer-content"]}>
          <span>
            {t("footer.need_help")}{" "}
            <JokerButton
              href="/chat"
              text={t("footer.chat")}
              type={ButtonType.Link}
              underlined
            />
          </span>
          <span className={styles["security-text"]}>
            {t("footer.security_text")}
            <JokerButton
              href="/security-policy"
              text={t("footer.security_policy")}
              type={ButtonType.Link}
              underlined
            />
            .
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
